import React from 'react';
import { Form, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { PLAN_OWNER_CREATE } from '../../../graphql/mutations/planOwners';
import { PlanOwnerForm } from '../../../components/PlanOwner/PlanOwnerForm';
import CardLayout from '../../../layouts/CardLayout';
import { IPlanOwnerPhoto, PlanOwnerFormValues } from '../../../types/planOwner';

const PlanOwnerCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [createPlanOwner, { loading }] = useMutation(PLAN_OWNER_CREATE, {
    onCompleted: data => {
      message.success('Plan owner successfully created');
      navigate(`/admin/plan-owner/${data.planOwnerCreate.id}`);
    },
    onError: error => {
      message.error(error.message);
    },
  });

  const onFinish = async (values: PlanOwnerFormValues) => {
    try {
      const photos = values.photos?.map((photo: IPlanOwnerPhoto) => photo.url);
      const logo = (Array.isArray(values.logo) && values.logo[0]?.url) || '';

      await createPlanOwner({
        variables: {
          ...values,
          photos,
          logo,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CardLayout>
      <PlanOwnerForm
        form={form}
        onFinish={onFinish}
        loading={loading}
        submitText="Create Plan Owner"
      />
    </CardLayout>
  );
};

export default PlanOwnerCreate;
